module.exports = __webpack_public_path__ + "static/img/2.91dfd5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/panorama/2.jpg
// module id = CL9h
// module chunks = 1